import { render } from "./TermsOfUse.vue?vue&type=template&id=2a33e504&scoped=true&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import "./TermsOfUse.vue?vue&type=style&index=0&id=2a33e504&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a33e504"]])

export default __exports__